<bp-property-metadata-views-section
	heading="Preset Details"
	[entity]="entity"
	[metadata]="metadata"
	[sectionScheme]="sectionScheme"
>
	<bp-credit-card-name *bpCustomValueView="'creditCardId'; let value" [id]="value" [compact]="true">
	</bp-credit-card-name>
</bp-property-metadata-views-section>
